export const apiDataKeyLogin = "APILoginIdentifyUser";
export const apiDataKeyGetMenu = "ERPIdx-UserMenu-Get";
export const apiDataKeyGetDashboardCharts = "ERP-Dashboard-Charts-Get";
export const apiDataKeyExplorerToolbarData = "ERP-ExplorerToolbarData-Get";
export const apiDataKeyCOLSUserStateSave = "ERP-COLSUserState-Save";
